<template>
	<!--div>
		<hr />
		Wrapper: {{ this.category ? this.category.name : 'Ingen kategori vald' }}
		<hr />
		<select v-model="selectedCategoryInList" @change="changedX()">
			<option :value="null">Välj kategori</option>
			<option v-for="category in this.categoryModel && this.categoryModel.categoryList" :key="category.categoryId"
				:value="category">{{ category.path }}
			</option>
		</select>
		<hr />
		<SelectCategory :categoryModel="this.categoryModel" :category="this.category"
			@categorySelected="(category) => this.category = category" />
		<hr />
		<SelectCategoryBR :categoryModel="this.categoryModel" :category="this.category"
			@categorySelected="(category) => this.category = category" />
	</div-->
	<SelectCategory v-if="!this.bread" :categoryModel="this.categoryModel" :category="this.category"
		@categorySelected="(category) => this.category = category" style="z-index:8;" />

	<SelectCategoryBR v-if="this.bread" :categoryModel="this.categoryModel" :category="this.category"
		@categorySelected="(category) => this.category = category" style="z-index:5;" />
</template>
<script>

import SelectCategory from '@/components/product/search/SelectCategory.vue';
import SelectCategoryBR from '@/components/product/search/SelectCategoryBR.vue';
import { STORE_GETTER } from '@/store/store';
import categoryHelper from '@/helper/category-helper';

//import { STORE_GETTER } from '@/store/store';

export default {
	name: "SelectCategoryWrapper",
	components: { SelectCategory, SelectCategoryBR },
	mixins: [],
	props:{
		bread: Boolean
	},
	data() {
		return {
			category: null,
			selectedCategoryInList: null
		};
	},
	computed: {

		/*categoryModel() {

			const baseModel = this.$store.getters[STORE_GETTER.BASE_MODEL]

			if (baseModel && baseModel.categoryModel) {
				return baseModel.categoryModel
			}

			return null;
		},*/
		categoryModel(){
			return this.$store.getters[STORE_GETTER.CATEGORY_MODEL]
		}


	},
	watch: {
		category: function (category) {

			if (category == null) {
				this.selectedCategoryInList = null;

			} else {
				this.selectedCategoryInList = this.categoryModel.categoryList.find(c => c.categoryId == category.categoryId)
			}


		},
	},
	methods: {
	
		changedX() {
			console.log('FP: changeX: ', this.selectedCategoryInList);

			if (this.selectedCategoryInList && this.selectedCategoryInList.categoryId) {
				const category = categoryHelper.findInCategoryTree(this.selectedCategoryInList.categoryId, this.categoryModel.categoryTree)
				console.log('FP: changeX: found: ', category);
				this.category = category
				
			} else {
				this.category = null;
			}

			//this.category = this.findInCategoryTree(category.categoryId);
			//alert("category: " + this.selectedCategoryInList.categoryId)
		}


	},
	created() {

	}
};
</script>

<style scoped></style>